import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "../../../hook/use-search-params";
import { NotifyService } from "../../../services/notify/notify-service";

export const useDetailsNotiy = () => {
  const { searchParams } = useSearchParams();
  const notifyId = searchParams.get("notifyId") || "";
  
  const { data, isLoading } = useQuery({
    queryKey: ["details-notify", notifyId],
    queryFn: () => NotifyService.getNotifyWithId(notifyId),
    enabled: !!notifyId,
  });

  return { data, isLoading };
};
